export const TRACKER_UPGRADE_PLAN_CLICK = '[Upgrade To Live Chat Dialog] upgrade click';
